import { REFERRAL_SOURCES, type ReferralSource } from '../../types'

interface ReferralSourceFieldProps {
  value: ReferralSource | ''
  otherValue: string
  onChange: (source: ReferralSource | '') => void
  onOtherChange: (value: string) => void
  error?: boolean
}

export default function ReferralSourceField({
  value,
  otherValue,
  onChange,
  onOtherChange,
  error = false,
}: ReferralSourceFieldProps) {
  return (
    <div className={`p-4 rounded-lg ${error ? 'bg-red-50 border border-red-200' : 'bg-gray-50'}`}>
      <label className="block text-sm font-medium text-gray-700 mb-3">
        How did you hear about us? <span className="text-red-500">*</span>
      </label>
      <div className="space-y-2">
        {REFERRAL_SOURCES.map((source) => (
          <label key={source} className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="referralSource"
              value={source}
              checked={value === source}
              onChange={() => onChange(source)}
              className="w-4 h-4 text-sla-blue focus:ring-sla-blue"
            />
            <span className="text-gray-700">{source}</span>
          </label>
        ))}
      </div>

      {value === 'Other' && (
        <div className="mt-3 ml-6">
          <input
            type="text"
            value={otherValue}
            onChange={(e) => onOtherChange(e.target.value)}
            placeholder="Please specify..."
            maxLength={200}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sla-blue focus:border-transparent"
          />
          <p className="text-xs text-gray-500 mt-1">
            {otherValue.length}/200 characters
          </p>
        </div>
      )}
    </div>
  )
}
